import { PhoneNumberTypes } from 'Constants/enums';
import { ContactModelV2, IPhoneNumber } from 'Models/ContactModelV2';

export const getPhoneOptions = (
  phoneNumbers: IPhoneNumber[],
  onClick: (phoneNumber: string) => void
) => {
  return phoneNumbers.map((phoneNumber) => ({
    text: `${
      PhoneNumberTypes.find((type) => type.key === phoneNumber.type).text
    }: ${ContactModelV2.formatNumber(phoneNumber.number)}`,
    onClick: () => onClick(phoneNumber.number),
  }));
};
